import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { AxPortletExpandable } from "../../Limestone/AxPortlet/AxPortletExpandable";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";

interface IOrderHistoryInitData {
    cancellationAdditionalText: string;
}

@ModuleName("OrderHistory")
export class OrderHistory implements AxInit {
    public axLoading: AxLoading;

    private cancellationAdditionalText: string;
    private i18nHelper = new I18nHelper();

    constructor(private _Porlet = new AxPortletExpandable()) { }

    AxInit(init: IOrderHistoryInitData): void {
        this.axLoading = new AxLoading();

        AxLoad.LoadModule('BleQrCodes', {
            loadTicketBtnClass: '.ax-history-button--showQr',
            copyTextToClipboardBtnClass: '.ax-history-button--Qrlink'
        });


        this.cancellationAdditionalText = init.cancellationAdditionalText;

        this._Porlet.OnOpen('.cart-history button[data-trans]', (e, elem) => {
            let transNr = parseInt($(elem).attr('data-trans'));
            let posNr = parseInt($(elem).attr('data-pos'));
            this.LoadData(posNr, transNr);
        });

    }



    // ToggleTimings
    ToggleTimings(delegatedTarget: HTMLElement) {
        let $e = $(delegatedTarget);
        $e.next('.history__timeslot-accordion-box').slideToggle('fast');
        $e.find('i').toggleClass('las la-angle-down').toggleClass('las la-angle-up');
    }

    // LoadData
    LoadData(posNr: number, transNr: number) {
        let key: string = `#detail-${posNr}-${transNr}`;

        $(key).html("<div></div>"); // clear detail view before load

        this.axLoading.ShowLoadingIndicator($(key)[0]);

        AxessViewer.loadPartialView(
            '/Profile/_Details',
            { trans_id: transNr, posNr: posNr },
            ({ view, data: { postData, ticketDefIsKGT23, waiverIsEnabled, oneRISKProcessRequired, waiverCompeling, transactionNumber } }) => {
                $(key).html(view);

                $(key).find('.tv4_side__selection-timing--toggle').on('click', (x) => { this.ToggleTimings(x.delegateTarget); });

                this.addClickListenerCancelButton(posNr, transNr);

                AxLoad.ReloadModule('BleQrCodes', key);

                this.axLoading.HideLoadingIndicator($(key)[0]);

                AxLoad.LoadModules([
                    {
                        name: "OneRisk", initData: {
                        //    processIndicatorActive: @(ViewBag.Layout_SlimHeader ?? false ? "true" : "false"),
                        //    progressBarMode: @(Request.QueryString["Ref"] == "pit" ? 1 : 0),
                            postData,
                            ticketDefIsKGT23,
                            waiverIsEnabled,
                            oneRISKProcessRequired,
                            waiverCompeling,
                            transactionNumber,
                        }
                    },
                    {
                        name: "Invoice", initData: {}
                    }
                ]);
            }
        );
    }
    // addClickListenerCancelButton
    addClickListenerCancelButton(posNr: any, transNr: any) {
        let cancelButtons = document.getElementById(`detail-${posNr}-${transNr}`).getElementsByClassName("ax-history-button--cancel");

        if (cancelButtons.length > 0) {

            for (let i = 0; i < cancelButtons.length; i++) {
                cancelButtons[i].addEventListener("click", ev => {
                    let transNr = $(ev.target).attr('data-transNr');
                    let serialNr = $(ev.target).attr('data-serialNr');
                    let poolNr = $(ev.target).attr('data-poolNr');

                    this.confirmCancel(transNr, serialNr, poolNr, ev.target);
                });
            }
        }
    }
    // confirmCancel
    confirmCancel(transNr, serialNr, poolNr, button) {

        let apiRequestData = {
            serialNr: serialNr,
            transNr: transNr,
        };

        AxessViewer.ajaxRequest('/api/CancelationApi/GetTicketCancelationStatus',
            apiRequestData,
            (result) => {

                console.log(result);

                if (result.TicketIsCanceled) {
                    Swal.fire({
                        title: this.i18nHelper.GetTranslation(Translations.Error),
                        icon: 'warning',
                        showCancelButton: false,
                        html: '<div>' + 'already canceled' + '</div>',
                        showDenyButton: false,
                        footer: this.cancellationAdditionalText,
                        confirmButtonText: this.i18nHelper.GetTranslation(Translations.Cancel),
                        denyButtonText: this.i18nHelper.GetTranslation(Translations.Cancel),
                        cancelButtonText: this.i18nHelper.GetTranslation(Translations.Cancel)
                    }).then((result) => {

                    });
                } else {
                    let data = {
                        transNr: transNr,
                        serialNr: serialNr,
                        poolNr: poolNr
                    };

                    AxessViewer.loadPartialView('/Profile/GetCancelSweetAlertHtml', data, (result) => {
                        Swal.fire({
                            title: this.i18nHelper.GetTranslation(Translations.AreYouSure),
                            icon: 'warning',
                            showCancelButton: true,
                            html: result,
                            showDenyButton: false,
                            footer: this.cancellationAdditionalText,
                            confirmButtonText: this.i18nHelper.GetTranslation(Translations.Confirmation),
                            denyButtonText: this.i18nHelper.GetTranslation(Translations.Cancel),
                            cancelButtonText: this.i18nHelper.GetTranslation(Translations.Cancel)
                        }).then((result) => {
                            if (result.value) {
                                $(button).prop("disabled", true);
                                this.cancelTicket(transNr, serialNr);
                            } else if (result.isDenied) {

                            }
                        });
                    }, { dataType: 'html' });
                }
            }, {});


    }
    // cancelTicket
    cancelTicket(transNr, serialNr) {

        let that = this;

        const data = {
            transNr: transNr,
            serialNr: serialNr
        };

        that.axLoading.ShowLoadingIndicatorFixed($('.ax-body')[0]);

        AxessViewer.loadPartialView('/Profile/CancelTicket', data, function (resp) {

            that.axLoading.HideLoadingIndicator($('.ax-body')[0]);

            if (resp["error"] === false) {
                Swal.fire({
                    title: `${that.i18nHelper.GetTranslation(Translations.Success)}!`,
                    icon: 'success',
                    text: resp['message'],
                    confirmButtonText: that.i18nHelper.GetTranslation(Translations.Ok),
                    showConfirmButton: true
                }).then((result) => {
                    location.reload();
                });
            }
            else {
                Swal.fire({
                    title: `${that.i18nHelper.GetTranslation(Translations.Error)}!`,
                    text: resp['message'],
                    icon: 'error',
                    confirmButtonText: that.i18nHelper.GetTranslation(Translations.Ok)
                }).then(resp => {
                    location.reload();
                });
            }

        }, {
            silent: true
        });
    }
}